jQuery(function () {
    const storeLocation = Util.getCookie('store_location')
    if (!storeLocation) {
        GeoLocation.closestStore();
    }
    Modal.init();
    const queryParams = new URLSearchParams(location.search);
    const isGoogleUtmSource = queryParams.get('utm_source') == "google";
    const isPaidMedium = queryParams.get('utm_medium') == "paid";
    const isVperksCampaign = queryParams.get('utm_campaign') == "vperks";
    const isVperksGoogleAdsCampaign = isGoogleUtmSource && isPaidMedium && isVperksCampaign;
    const appointmentSource = queryParams.get('appointmentSource');
    
    if (isVperksGoogleAdsCampaign) {
        Util.setCookie('vperks_google_ads_campaign', true, 0.5);
    }

    if (queryParams && queryParams.has("paymentplans")) {
        Modal.createPaytomorrowModal();
    }

    let newCookie;

    if (!Util.getCookie('dni_column')) {
        const utmSource = queryParams.get('utm_source') ? queryParams.get('utm_source').toLowerCase() : undefined;
        const utmMedium = queryParams.get('utm_medium') ? queryParams.get('utm_medium').toLowerCase() : undefined;
        const utmTerm = queryParams.get('utm_term') ? queryParams.get('utm_term').toLowerCase() : undefined;
        const socialLinks = ['facebook', 'twitter', 'instagram', 'linkedin'];
        const searchEngines = ['google', 'bing', 'yahoo', 'opera', 'safari', 'duckduckgo', 'baidu'];
        // grab the domain origin, grab the last two bits, join then with a . in between, and prepend a .
        const cookieDomain = "." + document.location.origin.split(".").slice(-2).join(".");
        if (isVperksGoogleAdsCampaign) {
            newCookie = 'oilcallonlyad';
        }
        else if (utmSource === 'email') {
            newCookie = 'crmemailwebsite';
        }
        else if (utmMedium === 'referral' && socialLinks.includes(utmSource)) {
            newCookie = 'socialreferredwebsitecalls';
        }
        else if (utmMedium === 'social') {
            newCookie = 'socialreferredwebsitecalls';
        }
        else if (utmMedium === 'referral') {
            newCookie = 'websitereferral';
        }
        else if (utmMedium === 'cpc' && utmSource === 'google') {
            newCookie = 'ppcwebsitecalls';
        }
        else if (utmMedium === 'paid-tire' && utmSource === 'google') {
            newCookie = 'tirecallonlyad';
        }
        else if (searchEngines.some(searchEngine => document.referrer.toLowerCase().indexOf(searchEngine) !== -1)) {
            newCookie = 'websiteorganic';
        }
        else if (utmTerm == 'oilcallonlyad') {
            newCookie = 'oilcallonlyad';
        }
        else if (utmTerm == 'crmemailwebsite') {
            newCookie = 'crmemailwebsite';
        }
        else if (utmTerm == 'socialreferredwebsitecalls') {
            newCookie = 'socialreferredwebsitecalls';
        }
        else if (utmTerm == 'ppcwebsitecalls') {
            newCookie = 'ppcwebsitecalls';
        }
        else if (utmTerm == 'tirecallonlyad') {
            newCookie = 'tirecallonlyad';
        }
        else if (utmTerm == 'brakecallonlyad') {
            newCookie = 'brakecallonlyad';
        }
        else if (utmTerm == 'tiregce') {
            newCookie = 'tiregce';
        }
        else if (utmTerm == 'oilgce') {
            newCookie = 'oilgce';
        }
        else if (utmTerm == 'brakegce') {
            newCookie = 'brakegce';
        }
        else if (document.referrer === '') {
            newCookie = 'websitedirect';
        }
        else {
            newCookie = 'websitereferral';
        }
        Util.setCookie('dni_column', newCookie, false, cookieDomain);
        // grab current correct phone number, because php already ran, and will not see cookie that just got added
    } else {
        newCookie = Util.getDniColumn();
    }

    if (appointmentSource) {
        Util.setCookie('appointment_source', appointmentSource, 0.5);
    }

    if(storeLocation) {
        const apiRoute = `/wp-json/monro/v1/store?id=${storeLocation}`
        fetch(apiRoute)
            .then((response) => response.json())
            .then((store) => {
                const phoneNumber = store.data[0][newCookie];
                const clickThroughPhoneNumber = `+1${phoneNumber.replace(/\D/g, '')}`;
                jQuery(".dynamic-phone-number-text").empty().append(phoneNumber);
                jQuery(".dynamic-phone-number-call-button").attr('href', `tel:${clickThroughPhoneNumber}`);
                jQuery(".dynamic-phone-number-a").empty().append(`<a href="tel:${clickThroughPhoneNumber}"> ${phoneNumber}</a>`);
            });
    }
     
}
);